import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../redux/app/hooks';
import { STUDENT_ROLE, TEACHER_ROLE } from '../../utils/constants';
import './TeacherStudentSettings.scss';
import MobileHeader from '../../components/MobileHeader/MobileHeader';

const TeacherStudentSettings = () => {

    const role = useAppSelector((state) => state.auth.role);
    const navigate = useNavigate();

    const handleClick = () => {
        if (role === STUDENT_ROLE) {
            navigate('/student-settings/profile');
        } else if(role === TEACHER_ROLE) {
            navigate('/teacher-settings/profile')
        }
    };

    return (
        <div className="settingsMainContainer">
            <div className={`settingsContainer ${role === TEACHER_ROLE && 'settingsContainerTeacher'}`}>
                <div className='mobileSettingsHeader'>
                    <div className='mobileSettingsHeader'>Settings</div>
                    <MobileHeader />
                </div>
                <div className='titleMainContainer' onClick={handleClick}>
                    <div className='titleContainer'>
                        My Profile
                    </div>
                    <div className='subTitle'>
                        { role === STUDENT_ROLE ? "Add Profile image to your person details" : "View your profile details" }
                    </div>
                </div>
                <div className='divider' />
            </div>
        </div>
    )
}

export default TeacherStudentSettings;
